import { render, staticRenderFns } from "./WorkOrderDetailTabs.vue?vue&type=template&id=7bdc3d79"
import script from "./WorkOrderDetailTabs.vue?vue&type=script&lang=js"
export * from "./WorkOrderDetailTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports